"use client";

import React from "react";
interface TotpContextType {
  isTotpDialogOpen: boolean;
  setIsTotpDialogOpen: (isOpen: boolean) => void;
  totpSuccess: boolean;
  setTotpSuccess: (success: boolean) => void;
}
export const TotpContext = React.createContext<TotpContextType>({
  isTotpDialogOpen: false,
  setIsTotpDialogOpen: () => {},
  totpSuccess: false,
  setTotpSuccess: () => {}
});
export function TotpProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isTotpDialogOpen, setIsTotpDialogOpen] = React.useState(false);
  const [totpSuccess, setTotpSuccess] = React.useState(false);
  return <TotpContext.Provider value={{
    isTotpDialogOpen,
    setIsTotpDialogOpen,
    totpSuccess,
    setTotpSuccess
  }} data-sentry-element="unknown" data-sentry-component="TotpProvider" data-sentry-source-file="TotpProvider.tsx">
      {children}
    </TotpContext.Provider>;
}